import { AxiosPromise } from "axios";
import { route } from "../../shim/jsbridge";
import {
  ILoginCredentials,
  ILoginOptions,
  IPassRequestFormSubmit,
  IPassResetFormSubmit
} from "./@types";
import { AxiosApiWrapper } from "../../services/api/AxiosApiWrapper";

class Api extends AxiosApiWrapper {
  getLoginOptions = (): AxiosPromise<ILoginOptions[]> =>
    this.get(route("api_login_options"));

  login = (data: ILoginCredentials) => {
    const formBody = new FormData();
    formBody.append("username", data.username);
    formBody.append("password", data.password);
    formBody.append("next", data.next);
    return this.post(route("login"), formBody);
  };

  resetPasswordRequest = (data: IPassRequestFormSubmit) => {
    const changeRequestFormBody = new FormData();
    changeRequestFormBody.append("email", data.email);
    return this.post(route("password_reset"), changeRequestFormBody);
  };

  resetPasswordRules = (): AxiosPromise<string[]> =>
    this.get(route("api_password_reset_rules"));

  resetPasswordSubmit = (data: IPassResetFormSubmit) => {
    const { values, uidb64, token } = data;
    const resetFormBody = new FormData();
    resetFormBody.append("new_password1", values.password);
    resetFormBody.append("new_password2", values.repeatPassword);
    return this.post(
      route("password_reset_form", {
        uidb64,
        token
      }),
      resetFormBody
    );
  };
}

export default new Api();
